import Timer from '../common/timer'

const openMenus = [];
export default class PulldownMenu {
    enabled = true;
    open = false;
    externalClickCallback = evite.noop;

    static hideOpenMenus () {
        while(openMenus.length){
            openMenus.pop().hideMenu();
        }
    }

    constructor (options) {
        this.el = evite.assert(options.el);
        this.pulldown = this.el.querySelector('.pulldown-link');
        this.hideMenuTimer = new Timer(250, Number.POSITIVE_INFINITY);

        this.hideMenuTimer.on(Timer.TICK, this.hideMenu);

        if (evite.detects.isDesktop) {
            this.pulldown.addEventListener("mouseenter", this.handlePulldownMouseEnter);
            this.el.addEventListener('mousemove', this.handleMouseMove);
            this.el.addEventListener("mouseenter", this.stopEventPropagation);
            this.el.addEventListener("mouseover", this.stopEventPropagation);

            document.body.addEventListener('mouseover', this.handleFocusout);
        }
        else {
            this.pulldown.addEventListener("click", this.handlePulldownClickOnMobile);
        }
    }

    get menu() { return this.el.querySelector('.menu'); }

    setEnabled = (enabled) => {
        this.enabled = enabled;
        if (!enabled) {
            this.hideMenu();
        }
    };

    hideMenu = () => {
        if(!this.open){
            return;
        }

        this.open = false;
        this.hideMenuTimer.stop();
        this.menu.classList.add('hidden');
    };

    showMenu = () => {
        if(this.open || !this.enabled){
            return;
        }

        this.hideMenuTimer.stop();
        this.menu.classList.remove('hidden');
        this.open = true;

        if(openMenus.indexOf(this) === -1){
          openMenus.push(this);
        }
    };

    addPulldownClickCallback = (callback) => {
        this.externalClickCallback = callback || evite.noop;
    };

    handlePulldownClickOnMobile = (event) => {
        this.externalClickCallback();
    };

    handlePulldownMouseEnter = (event) => {
        event.stopPropagation();
        if(this.open){
            openMenus.splice(openMenus.indexOf(this), 1);
        }

        PulldownMenu.hideOpenMenus();
        if(this.open){
            openMenus.push(this);
        }
        else {
            this.showMenu();
        }

        this.externalClickCallback();
    };

    handleFocusout = (event) => {
        if(this.open && !this.hideMenuTimer.isRunning){
            this.hideMenuTimer.start();
        }
    };

    handleMouseMove = (event) => {
      if(this.hideMenuTimer.isRunning){
          this.hideMenuTimer.stop();
      }
    };

    stopEventPropagation = (event) => {
        event.stopPropagation();
    };
}



// WEBPACK FOOTER //
// ./assets/es6/nav/pulldown.es6